import React from 'react';
import { cn } from "@/lib/utils";
import { TableColumn } from '../../agent-performance/tableConfig';

interface AgentMetricsTableHeaderRowProps {
  columns: TableColumn[];
}

export const AgentMetricsTableHeaderRow: React.FC<AgentMetricsTableHeaderRowProps> = ({ columns }) => {
  return (
    <div className="table-row bg-gray-50 text-xs font-medium text-teamscx-primary border-b border-t border-gray-300 dark:bg-[#3C5C73] dark:text-white dark:border-white sticky top-0 z-10">
      {columns.map((col, colIndex) => (
        <div
          key={col.key}
          className={cn(
            "table-cell h-[45px] px-2 text-center transition-colors border-gray-300 dark:border-white align-middle",
            "border-b dark:border-t border-gray-300 dark:border-white font-bold",
            colIndex === 0 && "px-6"
          )}
          style={{
            minWidth: colIndex === 0 ? '200px' : col.minWidth,
            maxWidth: colIndex === 0 ? '265px' : col.maxWidth,
            width: colIndex === 0 ? '240px' : `calc((100% - 240px) / ${columns.length - 1})`
          }}
        >
          <div className="text-left px-4 capitalize font-medium">
            {col.title}
          </div>
        </div>
      ))}
    </div>
  );
};